export default "__VITE_ASSET__COoMnIY0__"